import React, { useState } from "react";

import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";


export default function DialogNewSchedule({ gerarHorarios, confirmGerar }) {
    const [showConfirm, setShowConfirm] = useState(false);

    return (
        <>
            <Button
                onClick={async () => {
                    if (confirmGerar) {
                        setShowConfirm(true);
                    } else {
                        await gerarHorarios();
                    }
                }}
                style={{ margin: 20, alignSelf: "flex-end" }}
            >
                Gerar Horários
            </Button>
            {showConfirm && (
                <Dialog
                    open={showConfirm}
                    keepMounted
                    onClose={() => setShowConfirm(false)}
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle>{"Toda a agenda da rodada será cancelada"}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-slide-description">
                            {`Ao confirmar toda a agenda da rodada será liberada`}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={async () => {
                                await gerarHorarios;
                                setShowConfirm(false);
                            }}
                        >
                            Confirmar
                        </Button>
                        <Button onClick={() => setShowConfirm(false)}>Cancelar</Button>
                    </DialogActions>
                </Dialog>
            )}
        </>
    );
}
